import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/** The vendors a file can be uploaded for, loaded only while the dialog is open. */
export function useVendorPortalUploadTargets(enabled: boolean) {
  return useQuery({
    ...orpc.pricing.vendorPortalFiles.listUploadTargets.queryOptions(),
    enabled,
  });
}

/** Upload one file for a Vendor Account, then refresh the list (and its counts). */
export function useUploadVendorPortalFile() {
  const queryClient = useQueryClient();
  return useMutation({
    ...orpc.pricing.vendorPortalFiles.upload.mutationOptions(),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: orpc.pricing.vendorPortalFiles.list.key(),
      }),
  });
}
